module.exports = __webpack_public_path__ + "img/1992_S.880d0930.png";